import React from "react";
import { LuSearch} from "react-icons/lu";

export default function OrdersFilters({
  dateRange = { start_date: "", end_date: "" },
  onDateRangeChange = () => {},
  search = "",
  onSearchChange = () => {},
}) {

  // Format date for input fields (YYYY-MM-DDTHH:mm)
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    // Handle both full ISO format and simplified format
    if (dateString.includes("T") && dateString.length > 16) {
      return dateString.slice(0, 16);
    }
    return dateString;
  };

  // Handle from date change
  const handleFromDateChange = (e) => {
    const value = e.target.value;
    if (value) {
      onDateRangeChange({
        ...dateRange,
        start_date: value // Store as "YYYY-MM-DDTHH:mm"
      });
    } else {
      onDateRangeChange({
        ...dateRange,
        start_date: ""
      });
    }
  };

  // Handle to date change
  const handleToDateChange = (e) => {
    const value = e.target.value;
    if (value) {
      onDateRangeChange({
        ...dateRange,
        end_date: value // Store as "YYYY-MM-DDTHH:mm"
      });
    } else {
      onDateRangeChange({
        ...dateRange,
        end_date: ""
      });
    }
  };

  return (
    <div className="orders-filters">
      <div className="of-left">
        <div className="of-date-inline">
          <div className="of-date-field">
            <label htmlFor="from_date">From</label>
            <input
              id="from_date"
              type="datetime-local"
              value={formatDateForInput(dateRange.start_date)}
              onChange={handleFromDateChange}
              className="of-date-input"
            />
          </div>
          <div className="of-date-field">
            <label htmlFor="to_date">TO</label>
            <input
              id="to_date"
              type="datetime-local"
              value={formatDateForInput(dateRange.end_date)}
              onChange={handleToDateChange}
              className="of-date-input"
            />
          </div>
        </div>
      </div>

      <div className="of-right">
        <div className="of-search">
          <LuSearch size={18} className="of-search-ico" />
          <input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search order ID | customer.. etc"
            aria-label="Search orders"
          />
        </div>

    
      </div>
    </div>
  );
}

